module.exports = __webpack_public_path__ + "img/KSC04681.4faf6170.jpg";